import SpotlightWinbackBannerV2 from './SpotlightWinbackBannerV2'

export default SpotlightWinbackBannerV2
// eslint-disable-next-line import/export
export * from './SpotlightWinbackBannerV2'
